import { Component, OnInit } from '@angular/core';

import { delay } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { EmpleadoService } from '../../../services/empleado.service';
import { SubAreaService } from '../../../services/subarea.service';

import { EmployeeModel } from '../../../models/employee.model';
import { SubAreaModel } from '../../../models/subarea.model';
import { AreaModel } from '../../../models/area.model';
import { AreaService } from '../../../services/area.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-empleado',
    templateUrl: './empleado.component.html',
    styles: [],
    standalone: false
})
export class EmpleadoComponent implements OnInit {


  public empleadoForm: UntypedFormGroup
  public areas: AreaModel[] = [];
  public subareas: SubAreaModel[] = [];

  public empleadoSeleccionado: EmployeeModel;
  public areaSeleccionado: AreaModel;
  public subareaSeleccionado: SubAreaModel;

  public areaname: string = '';


  typedocList = [
                'ID',
                'Passpost',
                'Other'
              ];

  constructor( private fb: UntypedFormBuilder,
               private router: Router,
               private activatedRoute: ActivatedRoute,
               private empleadosService: EmpleadoService,
               private areasService: AreaService,
               private subareasService: SubAreaService) { }



  ngOnInit(): void {

    this.activatedRoute.params.subscribe( ({ id }) => {
      this.cargarEmpleado(id);
    });

    this.empleadoForm = this.fb.group({
      name: [ '', Validators.required ],
      lastname: [ '', Validators.required ],
      typedoc: [ '', Validators.required ],
      document: [ '', Validators.required ],
      area: [ '', Validators.required ],
      subarea: [ '', Validators.required ],

    });




    this.cargarAreas();

    this.empleadoForm.get('area').valueChanges
                      .subscribe( areasId => {
                        if(areasId){
                          this.areaSeleccionado = this.areas.find(h => h._id === areasId);
                          this.subareas = this.areaSeleccionado.subareas;
                        }

                      });


    this.empleadoForm.get('subarea').valueChanges
                      .subscribe( subareasId => {

                        console.log(subareasId);
                        if(subareasId){
                          this.subareaSeleccionado = this.subareas.find(h => h._id === subareasId);
                          this.areaname = this.areas.find(h => h._id === this.empleadoForm.get('area').value).name;
                        }


                      });



  }



  nuevoEmpleado(){
    this.empleadoSeleccionado = null;
    const newList_typedoc = [...new Set(this.typedocList)];
    this.typedocList = newList_typedoc;
    this.router.navigateByUrl('/dashboard/employee/nuevo');
    this.empleadoForm.reset();
    setTimeout(() => {
      this.ngOnInit();
    }, 200);
 }
  cargarEmpleado( id: string ) {
    if ( id === 'nuevo') {
      return;
    }
    this.empleadosService.obtenerEmpleadoPorId( id )
                        .pipe(
                          delay(100)
                        )
                        .subscribe( empleado => {


                          if ( !empleado ) {
                            return this.router.navigateByUrl(`/dashboard/employee`);
                          }

                          this.typedocList.push(empleado.typedoc);


                          const { name, lastname, typedoc, document, area, subarea:{ _id }} = empleado;
                          this.empleadoForm.setValue({ name, lastname, typedoc, document,  area: area._id, subarea: _id});

                          this.empleadoSeleccionado = empleado;

                        });

  }





  cargarAreas() {

    this.areasService.cargarAreas()
                          .subscribe( areas => {
                            this.areas = areas;
                          });

  }

  cargarSubareas() {

    this.subareasService.cargarSubAreas()
                          .subscribe( subareas => {
                              this.subareas = subareas;
                          });



  }

  guardarEmpleado() {
    const {name, lastname} = this.empleadoForm.value;
    if ( this.empleadoSeleccionado ) {
      const data = {
        ...this.empleadoForm.value,
        _id: this.empleadoSeleccionado._id
      };

      this.empleadosService.actualizarEmpleado( data )
                    .subscribe( (resp: any) => {

                      Swal.fire(
                        'Employess Updated',
                      `${ name } ${ lastname }`,
                        'success'

                      );

                    });


    } else {

          this.empleadosService.crearEmpleado( this.empleadoForm.value )
                            .subscribe( (resp: any) => {
                              Swal.fire(
                                'Employee Resgistered',
                                `${ name } ${ lastname }`,
                                'success'
                              );

                              this.router.navigateByUrl(`/dashboard/employee/${ resp.employee._id }`);


                            }, err => {
                              console.log('HTTP Error', err.error);
                              Swal.fire({
                               title: '¡Error!',
                               text: JSON.stringify(err.error.errors.name.msg),
                               icon: 'error',
                               confirmButtonText: 'Close',
                               scrollbarPadding: false,
                               allowOutsideClick: false
                             });
                           });

          }
  }

}
